import { clsx } from 'clsx';
import HelperText from "./components/HelperText";
import Info from "./components/Info";
import Label from "./components/Label";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FormFieldDecoration = function FormFieldDecoration(_ref) {
  var hidden = _ref.hidden,
    full = _ref.full,
    containerClassName = _ref.containerClassName,
    hideLabel = _ref.hideLabel,
    label = _ref.label,
    tooltip = _ref.tooltip,
    size = _ref.size,
    state = _ref.state,
    subLabelElement = _ref.subLabelElement,
    info = _ref.info,
    helperText = _ref.helperText,
    childrenId = _ref.childrenId,
    children = _ref.children;
  var hasError = state === 'error';
  return /*#__PURE__*/_jsxs("div", {
    hidden: hidden,
    className: clsx(full ? 'tw-w-full' : 'tw-w-28', 'tw-gap-0.8  tw-flex-col', !hidden && 'tw-flex', containerClassName),
    children: [!hideLabel && /*#__PURE__*/_jsx(Label, {
      label: label,
      tooltip: tooltip,
      size: size,
      state: state
    }), subLabelElement, info && /*#__PURE__*/_jsx(Info, {
      info: info,
      inputState: state
    }), children, helperText && /*#__PURE__*/_jsx(HelperText, {
      text: helperText,
      inputId: childrenId,
      hasError: hasError
    })]
  });
};
export default FormFieldDecoration;